import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { CompanyStorageService } from 'src/app/core/company/company.storage';
import { environment } from 'src/environments/environment.prod';

@Component({
  selector: 'app-permohonan-kredit-detail-modal',
  templateUrl: './permohonan-kredit-detail-modal.component.html',
  styleUrls: ['./permohonan-kredit-detail-modal.component.scss'],
})
export class PermohonanKreditDetailModalComponent implements OnInit, OnDestroy {
  @Input() detail: any = {};
  @Input() pengajuan: any = {};
  @Input() leadId = '';

  loading = false;
  loadingDetail = false;
  loanDetail: any = {};
  private baseUrl: string;
  private detailSub?: Subscription;
  private detailRequestId = 0;

  constructor(
    private http: HttpClient,
    private modalController: ModalController,
    private companyStorage: CompanyStorageService,
  ) {
    this.baseUrl = environment.restURL.baseUrl;
  }

  ngOnInit() {
    this.loanDetail = this.detail || {};
    this.loadLoanDetail();
  }

  ngOnDestroy() {
    this.detailSub?.unsubscribe();
  }

  get actionDisabled(): boolean {
    return this.loading || this.loadingDetail || !this.hasDetailData();
  }

  close() {
    this.modalController.dismiss();
  }

  lanjutkanProses() {
    if (!this.leadId || this.loading) {
      return;
    }
    this.loading = true;
    const token = localStorage.getItem('usertoken') || '';
    const headers = new HttpHeaders()
      .set('Authorization', 'Bearer ' + token)
      .set('X-Tenant-Key', this.companyStorage.getVerifyToken());
    const url = `${this.baseUrl}backoffice/credit-analyst/checking-data/next/${this.leadId}`;

    this.http.post(url, {}, { headers }).subscribe(
      (data: any) => {
        this.loading = false;
        if (data?.error === 0 || data?.status === 200) {
          this.modalController.dismiss({ data }, 'confirm');
        }
      },
      () => {
        this.loading = false;
      },
    );
  }

  private loadLoanDetail() {
    if (!this.leadId) {
      return;
    }

    const token = localStorage.getItem('usertoken') || '';
    const headers = new HttpHeaders()
      .set('Authorization', 'Bearer ' + token)
      .set('X-Tenant-Key', this.companyStorage.getVerifyToken())
      .set('Accept', 'application/json')
      .set('Content-Type', 'application/json');

    const requestId = ++this.detailRequestId;
    this.loadingDetail = true;
    this.detailSub?.unsubscribe();
    this.detailSub = this.http
      .get(`${this.baseUrl}backoffice/credit-analyst/loan/${this.leadId}`, { headers })
      .subscribe(
        (res: any) => {
          if (requestId !== this.detailRequestId) {
            return;
          }
          this.loadingDetail = false;
          if (res?.error === 0 && res?.data) {
            this.loanDetail = res.data;
          }
        },
        () => {
          if (requestId !== this.detailRequestId) {
            return;
          }
          this.loadingDetail = false;
        },
      );
  }

  private hasDetailData(): boolean {
    const detail = this.loanDetail || {};
    return !!(
      detail.no_surat ||
      detail.nomorSurat ||
      detail.pokok_pinjaman ||
      detail.pokokPinjaman ||
      detail.angsuran ||
      detail.jangka_waktu ||
      detail.jangkaWaktu ||
      detail.suku_bunga ||
      detail.sukuBunga ||
      detail.jangka_waktu ||
      detail.jangkaWaktu ||
      detail.angsuran ||
      detail.blokir_tabungan ||
      detail.blokirTabungan ||
      detail.provisi ||
      detail.denda ||
      detail.biaya_asuransi ||
      detail.biayaAsuransi ||
      detail.biaya_cek_sertfikat ||
      detail.biayaCekSertifikat ||
      detail.biaya_fiducia ||
      detail.biayaFiducia ||
      detail.biaya_legalisasi ||
      detail.biayaLegalisasi ||
      detail.waarmeking ||
      detail.biayaWaarmeking
    );
  }
}
